import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { features } from '@h2/components/media'
import { Modal } from '@h2/components/containers/modal'
import { closeDialog, openSigninDialog } from '@main/actions/signinOrRegisterDialog'

import { SignInForm } from '../signInForm'
import { Registration } from '../registration'
import { Join } from '../registration/join'
import { userCompletedDialogRegistration } from '../../actions/userCompletedDialogRegistration'
import { userForgotCredential } from '../../actions/userForgotCredential'

const getDialogPadding = ({ dialog }) => {
  if (dialog === 'createAccount') {
    // Add top padding to dialog content area to make room for closing X icon
    return `
      & + div > div:nth-child(2) {
        padding-top: 65px;
      }
    `
  }

  return null
}
const CloseButton = styled.button`
  border: 0;
  padding: 0;
  width: auto;
  background: transparent;
  display: inline-block;
`
const Wrap = styled.div`
  position: relative;

  && > ${CloseButton} {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    color: white;

    svg {
      width: 24px;
      height: 24px;
    }

    & + div > div:first-child {
      padding-top: 40px;
    }

    @media (${features.minWidth.laptop}) {
      ${getDialogPadding};
      color: ${({ dialog }) => (dialog === 'signIn' ? 'white' : 'black')};
    }
  }
`
const dialogMap = {
  signIn: SignInForm,
  createAccount: Registration,
  resetRegistration: Registration,
  join: Join
}
const SignInOrRegisterDialog = ({
  isDialogRegActive = false,
  useModal = true,
  customDetourHandler,
  addMessage
}) => {
  const dispatch = useDispatch()
  const { isPopupOpened, tabId: dialog } = useSelector(
    state => state.signinOrRegisterDialog
  )
  const onClose = useCallback(() => {
    dispatch(closeDialog())
    dispatch(userForgotCredential(''))

    if (isDialogRegActive) {
      dispatch(userCompletedDialogRegistration())
    }
  }, [dispatch, isDialogRegActive])
  const Dialog = dialogMap[dialog]

  useEffect(() => {
    if (dialog === 'resetRegistration') {
      dispatch(openSigninDialog('createAccount'))
    }
  }, [dialog, dispatch])

  if (useModal) {
    return (
      <Modal
        isOpen={isPopupOpened || isDialogRegActive}
        isPadded={false}
        onClose={onClose}>
        <Modal.Body>
          <Wrap dialog={dialog}>
            <CloseButton onClick={onClose}>
              <FontAwesomeIcon
                icon="times"
                color={dialog === 'signIn' ? 'white' : 'black'}
                size="1x"
              />
            </CloseButton>
            <Dialog
              inDialog={true}
              customDetourHandler={customDetourHandler}
              reset={dialog === 'resetRegistration'}
              addMessage={addMessage}
            />
          </Wrap>
        </Modal.Body>
      </Modal>
    )
  }

  return (
    <Dialog
      inDialog={false}
      addMessage={addMessage}
      customDetourHandler={customDetourHandler}
      reset={dialog === 'resetRegistration'}
    />
  )
}

SignInOrRegisterDialog.propTypes = {
  isDialogRegActive: PropTypes.bool,
  useModal: PropTypes.bool,
  customDetourHandler: PropTypes.func,
  addMessage: PropTypes.string
}

export { SignInOrRegisterDialog }
